<template>
  <div class="body-wrap">
    <erp-tree @node-click="nodeClick"></erp-tree>
    <div class="body-main">

      <div class="operation-btns">
        <el-button size="mini" @click="getList()" :loading="searchLoading">查询</el-button>
        <el-button size="mini" @click="chargeModify()" :disabled="tableData.length == 0">调整</el-button>
        <!-- <el-button size="mini" @click="discountModify()" :disabled="tableData.length == 0" v-if="ERP.isPermission(4003007005)">调整减免金额(全部)</el-button> -->
      </div>

      <!-- 搜索 -->
      <div class="search-wrap" >

        <div class="sw-title">查询条件 <span class="house-name">{{form.house_name}}</span></div>
        <div class="sw-wrap">
          <el-descriptions title="" size="mini" :column="2" border :labelStyle="{width: '100px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="收费对象">
              <el-input size="mini" clearable="" v-model="form.CustomerName">
                <el-button slot="append" @click="showSearchCustomer('list')">选择</el-button>
              </el-input>
            </el-descriptions-item>
            <el-descriptions-item label="计费周期">
              <el-date-picker size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.BeginEndDate"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="收费项目">
              <el-select v-model="form.ChargeItemID" filterable placeholder="请选择" size="mini">
                <el-option v-for="item in chargeItemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="收费标准">
              <el-select v-model="form.ChargeID" placeholder="请选择" size="mini">
                <el-option v-for="item in chargeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="缴款状态">
              <el-checkbox-group v-model="form.IsPaid">
                <el-checkbox v-for="item in payStatusList" :key="item.value" :label="item.value">{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="减免状态">
              <el-checkbox-group v-model="form.IsDiscount">
                <el-checkbox :label="0">未减免</el-checkbox>
                <el-checkbox :label="1">已减免</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="账期">
              <el-date-picker type="month" format="yyyyMM" value-format="yyyyMM" v-model="form.AccountBook" size="mini" placeholder="选择日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="是否统计违约金">
              <el-radio-group v-model="form.IsDelaySum">
                <!-- <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio> -->
              </el-radio-group>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap" style="margin-top: 5px;">
        <el-table v-loading="searchLoading" height="47vh" border :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column prop="id" type="selection" width="50"></el-table-column>
          <el-table-column prop="h_name_date" label="房产名称"></el-table-column>
          <el-table-column prop="id" label="收费标准" width="180">
            <template slot-scope="scope">
              {{scope.row.charge_name}}
            </template>
          </el-table-column>
          <el-table-column prop="generate_date_formatted" label="生成日期"  width="138"></el-table-column>
          <el-table-column prop="ymt_formatted" label="帐期" width="80"></el-table-column>
          <el-table-column prop="start_end_date" label="计费周期" width="160"></el-table-column>
          <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
          <el-table-column prop="xsc_Amount" label="面积" width="90"></el-table-column>
          <el-table-column prop="charge" label="实际应收" width="80"></el-table-column>
          <el-table-column prop="not_pay_sum" label="本金欠费" width="80"></el-table-column>
          <el-table-column prop="delaySum" label="违约金" width="80"></el-table-column>
          <el-table-column prop="h_name" label="收费对象" width="80"></el-table-column>
          <el-table-column prop="id" label="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{getStateText(scope.row)}}/{{getClosingText(scope.row.is_closing)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="total" :current-page="page" :page-size="pageSize" @on-change="pageChange" show-total />
        </div>
      </div>
      <!-- <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
      </div> -->
    </div>

    <!-- 调整 -->
    <el-dialog title="应收费用调整" :visible.sync="editDialogVisible" :close-on-click-modal="true" class="business-dialog" width="1000px">
      <div style="color: red;" v-if="editDialogLoading == true">保存中...</div>
      <el-descriptions title="" size="mini" :column="2" border>
        <el-descriptions-item label="房产">
          <!-- <el-input size="mini" v-model="editForm.h_name_date" disabled></el-input> -->
          {{editForm.h_name_date}}
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <!-- <el-input size="mini" v-model="editForm.start_end_date" disabled></el-input> -->
          {{editForm.start_end_date}}
        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <!-- <el-input size="mini" v-model="editForm.charge_item_name" disabled></el-input> -->
          {{editForm.charge_item_name}}
        </el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>

        <el-descriptions-item label="计费起始日期">
          <el-date-picker type="date" v-model="editForm.start_date_formatted" size="mini" placeholder="选择日期" :disabled="disableEdit"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="计费结束日期">
          <el-date-picker type="date" v-model="editForm.end_date_formatted" size="mini" placeholder="选择日期" :disabled="disableEdit"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="应收日期">
          <el-date-picker type="date" v-model="editForm.should_charge_date_formatted" size="mini" placeholder="选择日期" :disabled="disableEdit"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>

        <el-descriptions-item label="面积/数量" v-if="disable_type == 2">
          <el-input size="mini" v-model="editForm.xsc_Amount"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="面积/数量" v-else>
          <el-input size="mini" v-model="editForm.xsc_Amount" :disabled="disableEdit"></el-input>
        </el-descriptions-item>


        <el-descriptions-item label="收费对象">
          {{editForm.h_name}}<el-button size="mini" type="primary" icon="el-icon-user-solid" @click="showSearchCustomer('edit')" style="margin-left: 5px;">选择</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="缴费对象类型" v-if="disableEdit == false">
          <el-select v-model="editForm.paid_customer_type" placeholder="请选择" size="mini" :disabled="disableEdit">
            <el-option v-for="item in PaidCustomerTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="应收金额" v-if="disableEdit == false">
          <el-input size="mini" v-model="editForm.chargePay" :disabled="disableEdit" @change="calcPrice"></el-input>
        </el-descriptions-item>

        <el-descriptions-item label="收费标准">
          <el-select v-model="editForm.charge_id" placeholder="请选择" size="mini" @change="changeChargeId">
            <el-option v-for="item in chargeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          单价：{{editForm.charge_value}}
        </el-descriptions-item>
        <el-descriptions-item label="">
          <el-checkbox v-model="editForm.sync_house_charge_set" :disabled="true">同步更新房间收费设置</el-checkbox>
        </el-descriptions-item>

        <el-descriptions-item label="减免金额" v-if="disableEdit == false && ERP.isPermission(4003007005)">
          <!-- 有权限控制 -->
          <!-- <div style="display: flex;">
            <el-select v-model="editForm.discountType" clearable placeholder="请选择" size="mini" style="flex: 2;" :disabled="disableEdit">
              <el-option v-for="item in discount_type" :key="item.id" :label="item.name" :value="item.number"></el-option>
            </el-select>
            <el-input size="mini" v-model="editForm.discount" style="margin-left: 10px; flex: 1;" :disabled="disableEdit" @change="calcPrice"></el-input>
          </div> -->
          <!-- 直接不给修改 -->
          <div style="display: flex;">
            <el-select v-model="editForm.discountType" clearable placeholder="请选择" size="mini" style="flex: 2;" :disabled="true">
              <el-option v-for="item in discount_type" :key="item.id" :label="item.name" :value="item.number"></el-option>
            </el-select>
            <el-input size="mini" v-model="editForm.discount" style="margin-left: 10px; flex: 1;" :disabled="true" @change="calcPrice"></el-input>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="实际应收" v-if="disableEdit == false">
          <!-- <el-input size="mini" v-model="editForm.charge"></el-input> -->
          <el-input size="mini" v-model="editForm.charge" :disabled="true"></el-input>
        </el-descriptions-item>

        <el-descriptions-item label="备注">
          <el-input size="mini" v-model="editForm.remark"></el-input>
        </el-descriptions-item>

        <el-descriptions-item label="本金欠费">
          <el-input size="mini" v-model="editForm.not_pay_sum" :disabled="true"></el-input>
        </el-descriptions-item>

      </el-descriptions>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveModify">保 存</el-button>
        <el-button @click="editDialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 调整减免 -->
    <el-dialog title="应收费用减免金额调整" :visible.sync="editDialogVisible2" :close-on-click-modal="true" class="business-dialog" width="1000px">
      <el-descriptions title="" size="mini" :column="2" border>
        <el-descriptions-item label="房产">
          <!-- <el-input size="mini" v-model="editForm.h_name_date" disabled></el-input> -->
          {{editForm.h_name_date}}
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <!-- <el-input size="mini" v-model="editForm2.start_end_date" disabled></el-input> -->
          {{editForm2.start_end_date}}
        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <!-- <el-input size="mini" v-model="editForm2.charge_item_name" disabled></el-input> -->
          {{editForm2.charge_item_name}}
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select v-model="form.ChargeID" placeholder="请选择" size="mini" style="width: 100%;">
            <el-option v-for="item in chargeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="减免类型">
          <el-select v-model="editForm2.discountType" placeholder="请选择" size="mini">
            <el-option v-for="item in discount_type" :key="item.id" :label="item.name" :value="item.number"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="减免金额">
          <div style="display: flex;">
            <div style="flex: 1; display: flex; align-items: center;">
              <el-radio-group v-model="editForm2.discountAction">
                <el-radio :label="1">按金额</el-radio>
                <el-radio :label="2">按比率</el-radio>
              </el-radio-group>
            </div>
            <div style="flex: 1;">
              <el-input size="mini" v-model="editForm2.discount">
                <template slot="append" v-if="editForm2.discountAction == 2">%</template>
              </el-input>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          <el-input size="mini" v-model="editForm2.remark"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label=""></el-descriptions-item>
      </el-descriptions>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveModify2" :loading="editDialogLoading2">保 存</el-button>
        <el-button @click="editDialogVisible2 = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 收费对象 -->
    <el-dialog title="收费对象" :visible.sync="customerDialogVisible" :close-on-click-modal="true" class="business-dialog" width="500px">
      <el-descriptions title="" size="mini" :column="1" border>
        <el-descriptions-item label="房号">
          <el-autocomplete size="mini" placeholder="请输入关键字搜索" clearable v-model="customerForm.house_name" :trigger-on-focus="false" :fetch-suggestions="queryCustomer" @select="selectCustomer" style="width: 100%"></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="客户名称">
          <el-input size="mini" v-model="customerForm.customer_name"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="">
          <el-button type="primary" @click="" @click="searchCustomer">搜 索</el-button>
        </el-descriptions-item>
      </el-descriptions>
      <el-table v-loading="customerSearchLoading" :data="customerData" height="400" style="margin-top: 10px;">
        <el-table-column prop="community_name" label="项目" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="identification_card" label="证件号" align="center"></el-table-column>
        <el-table-column prop="id" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="choiceCustomer(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 弹窗选择用户 -->
    <el-dialog title="选择客户" top="5vh" :visible.sync="userSelectorVisible" :close-on-click-modal="true" class="business-dialog" width="800px">
      <div>
        <room-user style="height: 600px;" ref="roomUser" :house="shouse"></room-user>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="roomUserSelect" >确 定</el-button>
        <el-button @click="userSelectorVisible = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import ErpTree from "../Common/erp-tree";
import RoomUser from '../Common/room-user.vue';
export default {
  name: 'area-tax',
  components: {ErpTree, RoomUser},
  data () {
    return {
      h_name_date:'',
      total: 0,
      tableData: [],
      keyword: '',
      page: 1,
      pageSize: 10,
      searchLoading: false,
      totalInfo: {},

      form: {
        pindex_id: '',
        house_name: '',
        CustomerName: '',
        house_id: '',
        BeginEndDate: [], // '2022-11-01', '2022-11-30'
        ChargeItemID: '',
        ChargeID: '',
        IsPaid: [],
        IsDiscount: [],
        AccountBook: '',
        IsDelaySum: 0,
      },

      chargeItemList: [],
      chargeList: [],
      payStatusList: [{label: '未缴款', value: 0}, {label: '部分缴款', value: 1}, {label: '已缴款', value: 2}],
      PaidCustomerTypeList: [{label: '请选择', value: 0}, {label: '业主', value: 1}, {label: '租户', value: 2}, {label: '开发商代缴', value: 3}],

      editDialogVisible: false,
      editDialogLoading: false,
      editForm: {
        sync_house_charge_set: false,
        discountType: '',
        remark: '',
        charge_id:'',
        xsc_Amount:''
      },
      selectedItemList: [],

      customerDialogVisible: false,
      customerSearchLoading: false,
      customerData: [],
      customerForm: {
        pindex_id: '',
        house_name: '',
        customer_name: '',
      },

      disableEdit: false,
      disableChargeEdit: false,

      editDialogVisible2: false,
      editDialogLoading2: false,
      editForm2: {
        discountAction: 1,
      },
      discount_type:[],
      userSelectorType: '',
      userSelectorVisible: false,
      disableEditsc:false,
      disable_type:1,
      shouse: ''

    }
  },
  mounted() {
    // this.getChargeItemList()
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
          this.discount_type = backdata.data.data;
    });
  },
  watch: {
    "form.HouseID": function(val) {
      this.getChargeList()
    },
    "form.ChargeItemID": function(val) {
      this.getChargeList()
    },
  },
  methods: {
    nodeClick(d) {
      this.disable_type = 1;
      let pindex_id = d.tree[0].id
      this.form.pindex_id = pindex_id
      this.getChargeItemList();
      this.customerForm.pindex_id = pindex_id
      this.form.house_name = d.tree.map(item => item.name).join('->')
      this.editForm.h_name_date = d.tree.map(item => item.name).join('->')
      this.h_name_date = d.tree.map(item => item.name).join('->')
      if(d.tree[d.tree.length-1].type==='room'){
        this.disable_type = 2;
      }
      if(this.form.ChargeItemID) {
        this.getChargeList()

        if(this.form.BeginEndDate.length > 0) {
          this.getList()
        }
      }
    },

    getItemName(id) {
      for(let k in this.chargeItemList) {
        if(this.chargeItemList[k].value == id) {
          return this.chargeItemList[k].label
        }
      }
    },

    getList() {
      if(this.form.house_name == '') {
        this.$message.warning('请选择房产！')
        return false
      }
      if(this.form.BeginEndDate == null){
        this.$message.warning('请选择计费周期！')
        return false
      }
      if(this.form.BeginEndDate.length == 0) {
        this.$message.warning('请选择计费周期！')
        return false
      }
      if(this.form.ChargeItemID == '') {
        this.$message.warning('收费项目！')
        return false
      }

      let params = Object.assign({page: this.page, page_size: this.pageSize}, this.form)
      this.searchLoading = true
      this.$myhttp.get('admin/getChargeOrderList', {params: params}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          if(res.total > 0) {
            let charge_sum = 0, not_pay_sum = 0, delay_sum = 0;
            res.data.forEach(item => {
              charge_sum += Number(item.charge)
              not_pay_sum += Number(item.not_pay_sum)
              delay_sum += Number(item.delaySum)
            })
            res.data.push({
              id: 0,
              xsc_Amount: '当前页合计',
              charge: charge_sum.toFixed(2),
              not_pay_sum: not_pay_sum.toFixed(2),
              delaySum: delay_sum.toFixed(2),
            })
            res.data.push({
              id: 0,
              xsc_Amount: '总合计',
              charge: res.total_info.charge_sum.toFixed(2),
              not_pay_sum: res.total_info.not_pay_sum.toFixed(2),
              delaySum: res.total_info.delay_sum.toFixed(2),
            })
          }
          this.tableData = res.data
          this.total = res.total
        } else {
          this.tableData = []
          this.total = 0
          this.message(res)
        }
        this.searchLoading = false
      })
    },

    getChargeList() {
      this.form.ChargeID = ''
      let params = {
        pindex_id: this.form.pindex_id,
        chargeItem_name_id: this.form.ChargeItemID
      }
      this.$myhttp.get('admin/getHouseCharge', {params: params}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          this.chargeList = res.data.map(item => {return {label: item.name + item.charge, value: item.id, charge: item.charge}})
        } else {
          this.chargeList = []
        }

        this.chargeList.unshift({label: '请选择...', value: ''})
      })
    },

    pageChange(data) {
      this.page = data
      this.getList()
    },

    getChargeItemList() {
      this.$myhttp.get('admin/getChargeItemList?pindex_id='+this.form.pindex_id).then(res => {
        this.chargeItemList = res.data.code == 200 ? res.data.data.map(item => {return {value: item.id, label: item.chargeItem_name}}) : []
      })
    },

    getChargeItemName(id) {
      for(let k in this.chargeItemList) {
        if(this.chargeItemList[k].value == id) {
          return this.chargeItemList[k].label
        }
      }
      return ''
    },

    getHouseCharge() {
      let params = {
        pindex: this.form.HouseID,
        chargeItem_name_id: this.form.ChargeItemID
      }
      this.$myhttp.get('admin/getHouseCharge', {params: params}).then(res => {
        this.chargeList = res.data.code == 200 ? res.data.data.map(item => {return {value: item.id, label: item.name}}) : []
      })
    },

    message(res) {
      this.$message({type: res.code == 200 ? 'success' : 'error', message: res.msg})
    },

    queryCustomer(val, callback) {
      this.$myhttp.get('admin/common/house_text', {params: {text: val}}).then(res => {
        callback(res.data.code == 200 ? res.data.data.map(item => {return {id: item.id, value: item.house}}) : []);
      })
    },

    selectCustomer(val) {
      this.form.house_id = val.id
    },

    getStateText(item) {

      if(item.state == 1) {
        return item.PaidChargeSum > 0 ? '部分缴款' : '未缴款'
      } else if(item.state == 2) {
        return '已缴款'
      } else if (item.state == 3) {
        return '已关闭'
      }

    },

    getClosingText(val) {
      switch(Number(val)) {
        case 0: return '未月结';
        case 1: return '已月结';
      }
    },

    chargeModify() {
      if(this.form.BeginEndDate == null){
        this.$message.warning('请选择计费周期！')
        return false
      }
      if(this.form.BeginEndDate.length == 0) {
        this.$message.warning('请选择计费周期！')
        return false
      }
      this.editDialogVisible = true

      this.disableEdit = true
      this.disableEditsc = true;
      this.disableChargeEdit = true
      this.editForm = {
        sync_house_charge_set: false,
        discountType: '',
        remark: '',
        charge_id:'',
        xsc_Amount:''
      }

      let list = this.selectedItemList.filter(item => item.id > 0)

      if(list.length == 1) {
        let item = Object.assign({}, this.selectedItemList[0])
        item.charge_item_name = this.getItemName(item.xsc_ChargeItemID_id)
        this.editForm = item
        this.disableEdit = false

        this.disableChargeEdit = false
        //console.log(this.editForm)

      } else if(list.length > 1) {

        let chargeIds = []
        for(let k in list) {
          let chargeId = Number(list[k].charge_id)
          if(chargeId > 0 && chargeIds.includes(chargeId) == false ) chargeIds.push(chargeId)
        }
        if(chargeIds.length == 1) {
          this.editForm.charge_id = Number(chargeIds[0])
          this.disableChargeEdit = false
        }
      }

      if(this.disable_type == 1){
        this.disableEditsc = false;
      }else{
        let item = Object.assign({}, this.selectedItemList[0])
        this.editForm.xsc_Amount = item.xsc_Amount;
      }

      if(this.editForm.charge_id) {
        this.changeChargeId1(this.editForm.charge_id)
      }

      if(!this.editForm.h_name_date){
        this.editForm.h_name_date = this.form.house_name;
        this.editForm.start_end_date = this.form.BeginEndDate[0]+'-'+this.form.BeginEndDate[1];
        this.editForm.charge_item_name = this.getChargeItemName(this.form.ChargeItemID);
      }
    },

    handleSelectionChange(data) {
      this.selectedItemList = data
    },

    //保存
    saveModify() {
      if(this.form.BeginEndDate == null){
        this.$message.warning('请选择计费周期！')
        return false
      }
      if(this.form.BeginEndDate.length == 0) {
        this.$message.warning('请选择计费周期！')
        return false
      }
      if(this.editDialogLoading == false){
        this.editDialogLoading = true
        // ERP.showLoading()
        let ids = this.selectedItemList.map(item => item.id).filter(id => id > 0)
        let data = Object.assign({ids: ids.join(','), disableChargeEdit: this.disableChargeEdit ? 1 : 0}, this.editForm,this.form)
        this.$myhttp.post('admin/OrderChargeModify', data).then(resp => {
          // ERP.hideLoading()
          this.editDialogLoading = false
          let res = resp.data
          this.message(res)
          if(res.code == 200) {
            this.editDialogVisible = false
            this.getList()
          }
        })
      }
    },

    saveModify2() {

      this.editDialogLoading2 = true
      let data = Object.assign({
        pindex_id: this.form.pindex_id,
        BeginEndDate: this.form.BeginEndDate,
        ChargeItemID: this.form.ChargeItemID,
      }, this.editForm2)
      data.ChargeID = this.form.ChargeID;
      data.h_name_date = this.editForm.h_name_date;
      data.discountAction = this.editForm2.discountAction;
      data.discountType = this.editForm2.discountType;
      this.$myhttp.post('admin/OrderDiscountModify', data).then(resp => {
        let res = resp.data
        this.message(res)
        this.editDialogVisible2 = false
        if(res.code == 200) {
          this.editDialogVisible2 = false
          this.getList()
        }
        this.editDialogLoading2 = false
      })

    },

    getHouseChargeItem(id) {
      for(let k in this.chargeList) {
        if(this.chargeList[k].value == id) {
          return this.chargeList[k]
        }
      }

    },

    showSearchCustomer(type) {
      this.userSelectorType = type
      this.userSelectorVisible = true
    },

    searchCustomer() {

      this.customerSearchLoading = true
      let params = Object.assign({}, this.customerForm)
      this.$myhttp.get('admin/getCustomerList', {params: params}).then(res => {
        this.customerSearchLoading = false
        this.customerData = res.data.code == 200 ? res.data.data : []
      })

    },

    choiceCustomer(data) {
      this.editForm.h_name = data.name
      this.editForm.h_name_idid = data.identification_card
      this.customerDialogVisible = false
    },
    //选择收费项
    changeChargeId(val) {
      let item = this.getHouseChargeItem(val)
      this.editForm.charge_name = item.label
      this.editForm.charge_value = item.charge
      //计算金额
      let ids = this.selectedItemList.map(item => item.id).filter(id => id > 0)
      let data = Object.assign({ids: ids.join(','), disableChargeEdit: this.disableChargeEdit ? 1 : 0}, this.editForm,this.form)
      this.$myhttp.post('admin/OrderChargeModifyMoney', data).then(resp => {
        let res = resp.data
        if(res.code == 200){
          this.editForm.chargePay = res.data.money;
          this.editForm.charge = res.data.discount_money;
          this.editForm.not_pay_sum = res.data.money;
        }
      })
    },
    changeChargeId1(val) {
      let item = this.getHouseChargeItem(val)
      this.editForm.charge_name = item.label
      this.editForm.charge_value = item.charge
    },

    calcPrice() {
      let changePay = Number(this.editForm.chargePay)
      let discount  = Number(this.editForm.discount)
      this.editForm.charge = (changePay - discount).toFixed(2)
    },

    discountModify() {

      if(this.form.IsPaid.length != 1 || this.form.IsPaid[0] != 0) {
        this.$message.warning('查询条件"缴款状态"必须单选"未缴款"！')
        return false
      }
      this.editForm.h_name_date =  this.h_name_date;
      this.editForm2.start_end_date = this.form.BeginEndDate[0] + ' ~ ' + this.form.BeginEndDate[1]
      this.editForm2.charge_item_name = this.getChargeItemName(this.form.ChargeItemID)
      this.editDialogVisible2 = true

    },

    roomUserSelect() {

      this.userSelectorVisible = false

      let user = this.$refs.roomUser.getUser();
      console.log(user)
      if(this.userSelectorType == 'list') {
        this.form.CustomerName = user.name
      } else {
        this.editForm.h_name = user.name
        this.editForm.user_id = user;
        this.editForm.h_name_idid = user.credentials_code.replace("\t", '')
      }



    }

  },

}
</script>
<style lang="scss" scoped>

  @import '../Project/common.scss';

  .el-button--small {
    padding: 7px 10px;
  }

  /deep/.el-input-group .el-input-group__append {
    padding: 0 15px;
  }

  /deep/.readonly .el-input__inner {
    background-color: #eee;
  }

  /deep/ .search-wrap {
    .el-radio,.el-checkbox {
      margin-right: 20px;
    }
  }

  /deep/ .room-user-selector .ivu-modal-wrap {
    z-index: 9999 !important;
  }

  .body-wrap {
    display: flex;

    .body-main {
      flex: 1;
      margin-left: 15px;
      width: calc(100% - 250px);
    }

    .search-wrap {
      width: 100%;
      border: 1px solid #EBEEF5;
      flex-direction: column;

      .sw-title {
        margin: 0;
        font-size: 12px;
        color: #909399;
        background: #fafafa;
        padding: 5px;
        border-bottom: 1px solid #EBEEF5;

        .house-name {
          margin-left: 20px;
        }
      }

      .sw-wrap {
        padding: 10px;


      }
    }
  }




</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/chargeModify.vue